export enum UserRolesEnum {
    'CUSTOMER' = 'customer',
    'ROOT_ROLE' = 'root_role',
    'AGENT' = 'agent'
}